export class CourseScoringOptionConstants{
    public static readonly Pass_Fail: number = 0;
    public static readonly Pass_Fail_Name: string = "Pass/Fail";
    public static readonly MinimumScore: number = 1;
    public static readonly MinimumScore_Name: string = "Minimum Score";
}
